module.exports = __webpack_public_path__ + "s/img/Bow@2x.54e4cd84.png";